var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { staticClass: "text-center", attrs: { cols: "12" } },
                    [
                      _c("h4", { staticClass: "title" }, [
                        _vm._v("Nova Ocorrência")
                      ])
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-card-text",
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { staticClass: "text-center", attrs: { cols: "12" } },
                    [
                      _vm.isAdmin
                        ? _c("v-select", {
                            attrs: {
                              label: "Tipos de Usuários",
                              dense: "",
                              outlined: "",
                              sele: "",
                              items: _vm.roles,
                              "no-data-text": "Não há tipos de usuários",
                              "persistent-hint": "",
                              "return-object": "",
                              disabled: _vm.disabled
                            },
                            model: {
                              value: _vm.role,
                              callback: function($$v) {
                                _vm.role = $$v
                              },
                              expression: "role"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "text-center", attrs: { cols: "12" } },
                    [
                      _c("v-select", {
                        attrs: {
                          label: "Tipo da ocorrência",
                          dense: "",
                          items: _vm.userTypes,
                          hint: _vm.userType.origin,
                          "item-text": "name",
                          "item-value": "id",
                          autofocus: true,
                          outlined: "",
                          "no-data-text": "Não há tipos",
                          "persistent-hint": "",
                          "return-object": "",
                          disabled: _vm.disabled
                        },
                        model: {
                          value: _vm.userType,
                          callback: function($$v) {
                            _vm.userType = $$v
                          },
                          expression: "userType"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "text-center", attrs: { cols: "12" } },
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "4" } },
                            [
                              _c("v-checkbox", {
                                attrs: {
                                  disabled: _vm.disabled,
                                  color: "green",
                                  label: "Secretaria"
                                },
                                model: {
                                  value: _vm.secretariaCheck,
                                  callback: function($$v) {
                                    _vm.secretariaCheck = $$v
                                  },
                                  expression: "secretariaCheck"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "4" } },
                            [
                              _c("v-checkbox", {
                                attrs: {
                                  disabled: _vm.disabled,
                                  color: "green",
                                  label: "Professor"
                                },
                                model: {
                                  value: _vm.professorCheck,
                                  callback: function($$v) {
                                    _vm.professorCheck = $$v
                                  },
                                  expression: "professorCheck"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "4" } },
                            [
                              _c("v-checkbox", {
                                attrs: {
                                  disabled: _vm.disabled,
                                  color: "green",
                                  label: "Aluno"
                                },
                                model: {
                                  value: _vm.alunoCheck,
                                  callback: function($$v) {
                                    _vm.alunoCheck = $$v
                                  },
                                  expression: "alunoCheck"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "text-center", attrs: { cols: "12" } },
                    [
                      _c("v-textarea", {
                        attrs: {
                          outlined: "",
                          disabled: _vm.disabled,
                          rows: 6,
                          counter: "2045",
                          label: "Descrição da ocorrência",
                          rules: [_vm.rules.length]
                        },
                        model: {
                          value: _vm.text,
                          callback: function($$v) {
                            _vm.text = $$v
                          },
                          expression: "text"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "text-center", attrs: { cols: "12" } },
                    [
                      _c("v-progress-circular", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.disabled == true,
                            expression: "disabled == true"
                          }
                        ],
                        attrs: { indeterminate: "", color: "green" }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c(
                "v-row",
                { attrs: { justify: "center", align: "center", wrap: "" } },
                [
                  _c(
                    "v-col",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.message.length > 0,
                          expression: "message.length > 0"
                        }
                      ],
                      staticClass: "text-center",
                      attrs: { cols: "12" }
                    },
                    [
                      _c("label", { staticClass: "label red--text" }, [
                        _vm._v(_vm._s(_vm.message))
                      ])
                    ]
                  ),
                  _c(
                    "v-col",
                    { staticClass: "text-center", attrs: { cols: "6" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "green",
                            outlined: "",
                            block: "",
                            disabled: _vm.disabled
                          },
                          on: { click: _vm.postAsyncOccurrence }
                        },
                        [_vm._v("Adicionar")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "text-center", attrs: { cols: "6" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "red", outlined: "", block: "" },
                          on: { click: _vm.closeDialog }
                        },
                        [_vm._v("Cancelar")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }